module.exports = __webpack_public_path__ + "static/media/Comfortable.004c5403.svg";